import { render } from "./EditLiquidationAttachments.vue?vue&type=template&id=173e25bf"
import script from "./EditLiquidationAttachments.vue?vue&type=script&lang=js"
export * from "./EditLiquidationAttachments.vue?vue&type=script&lang=js"

import "./EditLiquidationAttachments.vue?vue&type=style&index=0&id=173e25bf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__